import {
    DefaultModalsKeys,
    ModalsProvider,
} from '@speeki/global-ui-components';
import { StorageManager } from '@speeki/storage-manager';

import { getFingerprint } from '@utils/fingerprint';
import { useUserCompany } from '@utils/hooks/useUserCompany';

import { useLogin } from '@services/AuthService/useLogin';

import { useReactiveVar } from '@apollo/client';
import { sessionProcessingVar } from '@boot/reactiveVariables';
import { LoginFormValues } from '@domains/auth/organisms/LoginForm/LoginForm';

interface UseUserLoginProps {
    modalName?: keyof DefaultModalsKeys;
}

export const useUserLogin = ({ modalName }: UseUserLoginProps = {}) => {
    const companyUuid = StorageManager.getValue('tenantUuid');
    const sessionProcessing = useReactiveVar(sessionProcessingVar);

    const { data: userData } = useUserCompany();

    const tenantId = companyUuid ?? userData?.user.tenant?.uuid ?? '';

    const { handleLogin } = useLogin();

    const login = async (data: LoginFormValues) => {
        try {
            const fingerprint = await getFingerprint();

            await handleLogin({
                input: {
                    email: data.email,
                    fingerprint,
                    password: data.password,
                    tenantUuid: tenantId,
                    type: 'EMPLOYEE',
                },
            });

            modalName && ModalsProvider.close(modalName);
        } catch (error) {
            console.error('useUserLogin login() :: ', { error });
        }
    };

    return { login, sessionProcessing };
};
